/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coinvestments_Nrl_Signedtoggle2Inputs */

const en_coinvestments_nrl_signedtoggle2 = /** @type {(inputs: Coinvestments_Nrl_Signedtoggle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Signed`)
};

/**
* | output |
* | --- |
* | "Signed" |
*
* @param {Coinvestments_Nrl_Signedtoggle2Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const coinvestments_nrl_signedtoggle2 = /** @type {((inputs?: Coinvestments_Nrl_Signedtoggle2Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coinvestments_Nrl_Signedtoggle2Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_coinvestments_nrl_signedtoggle2(inputs)
});
export { coinvestments_nrl_signedtoggle2 as "coInvestments_nrl_signedToggle" }